<div class="graficos-container">

  <!-- Painel de visibilidade -->
  <div class="graficos-toggles">

    @if (exibirGraficosCategoriaPizza) {
      <label class="toggle-item">
        <input type="checkbox" [(ngModel)]="exibirPizzaCategoria" /> Receitas e Despesas por Categoria
      </label>
    }

    @if (exibirGraficosTipoPizza) {
      <label class="toggle-item">
        <input type="checkbox" [(ngModel)]="exibirPizzaTipo" /> Receitas e Despesas por Tipo
      </label>
    }

    <label class="toggle-item">
      <input type="checkbox" [(ngModel)]="exibirBarrasMensal" /> Receita e Despesa {{ labelGranularidade }}
    </label>
    <label class="toggle-item">
      <input type="checkbox" [(ngModel)]="exibirBarrasSaldo" /> Saldo {{ labelGranularidade }}
    </label>
    <label class="toggle-item">
      <input type="checkbox" [(ngModel)]="exibirSaldoAcumulado" /> Evolução do Saldo
    </label>

    @if (exibirGraficosCategoriaPizza) {
      <label class="toggle-item">
        <input type="checkbox" [(ngModel)]="barraSaldoPorCategoria.exibir" /> Saldo por Categoria
      </label>
    }

    @if (exibirGraficosTipoPizza) {
      <label class="toggle-item">
        <input type="checkbox" [(ngModel)]="barraSaldoPorTipo.exibir" /> Saldo por Tipo
      </label>
    }

  </div>

  <!-- Pizza por Categoria — somente RelatorioCaixa -->
  @if (exibirGraficosCategoriaPizza) {
    <div class="graficos-pizza-row">
      @if (pizzaCatReceita.chartData && pizzaCatReceita.exibir) {
        <div class="grafico-bloco">
          <div class="grafico-header">
            <p class="grafico-titulo">Receitas por Categoria</p>
            @if (pizzaCatReceita.podeNavegar) {
              <div class="grafico-nav">
                <button class="grafico-nav-btn" (click)="pizzaCatReceita.voltar()">Voltar</button>
                <button class="grafico-nav-btn" (click)="pizzaCatReceita.reset()">Início</button>
              </div>
            }
          </div>
          <p class="grafico-hint">Duplo clique para pesquisar@if (pizzaCatReceita.temOutros) {
            · Clique em "Outros" para detalhar
          }</p>
          <div (dblclick)="buscarCategoriaChart($event, pizzaCatReceitaRef, false)">
            <p-chart #pizzaCatReceitaRef type="doughnut" height="300px" [data]="pizzaCatReceita.chartData" [options]="chartOptionsPizza"
              (onDataSelect)="onClickPizzaCatReceita($event)" />
            </div>
          </div>
        }
        @if (pizzaCatDespesa.chartData && pizzaCatDespesa.exibir) {
          <div class="grafico-bloco">
            <div class="grafico-header">
              <p class="grafico-titulo">Despesas por Categoria</p>
              @if (pizzaCatDespesa.podeNavegar) {
                <div class="grafico-nav">
                  <button class="grafico-nav-btn" (click)="pizzaCatDespesa.voltar()">Voltar</button>
                  <button class="grafico-nav-btn" (click)="pizzaCatDespesa.reset()">Início</button>
                </div>
              }
            </div>
            <p class="grafico-hint">Duplo clique para pesquisar@if (pizzaCatDespesa.temOutros) {
              · Clique em "Outros" para detalhar
            }</p>
            <div (dblclick)="buscarCategoriaChart($event, pizzaCatDespesaRef, false)">
              <p-chart #pizzaCatDespesaRef type="doughnut" height="300px" [data]="pizzaCatDespesa.chartData" [options]="chartOptionsPizza"
                (onDataSelect)="onClickPizzaCatDespesa($event)" />
              </div>
            </div>
          }
        </div>
      }

      <!-- Pizza por Tipo — todos exceto TipoLancamento -->
      @if (exibirGraficosTipoPizza) {
        <div class="graficos-pizza-row">
          @if (pizzaTipoReceita.chartData && pizzaTipoReceita.exibir) {
            <div class="grafico-bloco">
              <div class="grafico-header">
                <p class="grafico-titulo">Receitas por Tipo</p>
                @if (pizzaTipoReceita.podeNavegar) {
                  <div class="grafico-nav">
                    <button class="grafico-nav-btn" (click)="pizzaTipoReceita.voltar()">Voltar</button>
                    <button class="grafico-nav-btn" (click)="pizzaTipoReceita.reset()">Início</button>
                  </div>
                }
              </div>
              <p class="grafico-hint">Duplo clique para pesquisar@if (pizzaTipoReceita.temOutros) {
                · Clique em "Outros" para detalhar
              }</p>
              <div (dblclick)="buscarCategoriaChart($event, pizzaTipoReceitaRef, true)">
                <p-chart #pizzaTipoReceitaRef type="doughnut" height="300px" [data]="pizzaTipoReceita.chartData" [options]="chartOptionsPizza"
                  (onDataSelect)="onClickPizzaTipoReceita($event)" />
                </div>
              </div>
            }
            @if (pizzaTipoDespesa.chartData && pizzaTipoDespesa.exibir) {
              <div class="grafico-bloco">
                <div class="grafico-header">
                  <p class="grafico-titulo">Despesas por Tipo</p>
                  @if (pizzaTipoDespesa.podeNavegar) {
                    <div class="grafico-nav">
                      <button class="grafico-nav-btn" (click)="pizzaTipoDespesa.voltar()">Voltar</button>
                      <button class="grafico-nav-btn" (click)="pizzaTipoDespesa.reset()">Início</button>
                    </div>
                  }
                </div>
                <p class="grafico-hint">Duplo clique para pesquisar@if (pizzaTipoDespesa.temOutros) {
                  · Clique em "Outros" para detalhar
                }</p>
                <div (dblclick)="buscarCategoriaChart($event, pizzaTipoDespesaRef, true)">
                  <p-chart #pizzaTipoDespesaRef type="doughnut" height="300px" [data]="pizzaTipoDespesa.chartData" [options]="chartOptionsPizza"
                    (onDataSelect)="onClickPizzaTipoDespesa($event)" />
                  </div>
                </div>
              }
            </div>
          }

          <!-- Receita e Despesa por período -->
          @if (chartBarrasMensal && exibirBarrasMensal) {
            <div class="grafico-bloco-full">
              <p class="grafico-titulo">Receita e Despesa {{ labelGranularidade }}</p>
              <p class="grafico-hint">Duplo clique para pesquisar por período</p>
              <div (dblclick)="buscarBarraChart($event, barraMensalRef)">
                <p-chart #barraMensalRef type="bar" height="320px" [data]="chartBarrasMensal" [options]="chartOptionsBarra" />
              </div>
              <p class="grafico-titulo">Variação Percentual {{ labelGranularidade }}</p>
              <p-chart type="bar" height="320px" [data]="chartVariacaoPercentual" [options]="chartOptionsPercentual" />
            </div>
          }

          <!-- Saldo por período -->
          @if (chartBarrasSaldo && exibirBarrasSaldo) {
            <div class="grafico-bloco-full">
              <p class="grafico-titulo">Saldo {{ labelGranularidade }}</p>
              <p class="grafico-hint">Duplo clique para pesquisar por período</p>
              <div (dblclick)="buscarBarraChart($event, barraSaldoRef)">
                <p-chart #barraSaldoRef type="bar" height="320px" [data]="chartBarrasSaldo" [options]="chartOptionsBarra" />
              </div>
              <p class="grafico-titulo">Variação Percentual do Saldo {{ labelGranularidade }}</p>
              <p-chart type="bar" height="320px" [data]="chartVariacaoPercentualSaldo" [options]="chartOptionsPercentual" />
            </div>
          }

          <!-- Evolução do Saldo -->
          @if (chartSaldoAcumulado && exibirSaldoAcumulado) {
            <div class="grafico-bloco-full">
              <p class="grafico-titulo">Evolução do Saldo</p>
              <p-chart type="line" height="320px" [data]="chartSaldoAcumulado" [options]="chartOptionsLinha" />
            </div>
          }

          <!-- Saldo por Categoria — somente RelatorioCaixa -->
          @if (exibirGraficosCategoriaPizza && barraSaldoPorCategoria.chartData && barraSaldoPorCategoria.exibir) {
            <div class="grafico-bloco-full">
              <div class="grafico-header">
                <p class="grafico-titulo">Saldo por Categoria</p>
                @if (barraSaldoPorCategoria.podeNavegar) {
                  <div class="grafico-nav">
                    <button class="grafico-nav-btn" (click)="barraSaldoPorCategoria.voltar()">Voltar</button>
                    <button class="grafico-nav-btn" (click)="barraSaldoPorCategoria.reset()">Início</button>
                  </div>
                }
              </div>
              <p class="grafico-hint">Duplo clique para pesquisar@if (barraSaldoPorCategoria.temOutros) {
                · Clique em "Outros" para detalhar
              }</p>
              <div (click)="onClickBarraSaldoPorCategoria($event, barraSaldoCategoriaRef)" (dblclick)="buscarCategoriaBarraSaldoChart($event, barraSaldoCategoriaRef, false)">
                <p-chart #barraSaldoCategoriaRef type="bar" [height]="barraSaldoPorCategoria.altura" [data]="barraSaldoPorCategoria.chartData" [options]="chartOptionsBarraSaldo" />
              </div>
            </div>
          }

          <!-- Saldo por Tipo — todos exceto TipoLancamento -->
          @if (exibirGraficosTipoPizza && barraSaldoPorTipo.chartData && barraSaldoPorTipo.exibir) {
            <div class="grafico-bloco-full">
              <div class="grafico-header">
                <p class="grafico-titulo">Saldo por Tipo</p>
                @if (barraSaldoPorTipo.podeNavegar) {
                  <div class="grafico-nav">
                    <button class="grafico-nav-btn" (click)="barraSaldoPorTipo.voltar()">Voltar</button>
                    <button class="grafico-nav-btn" (click)="barraSaldoPorTipo.reset()">Início</button>
                  </div>
                }
              </div>
              <p class="grafico-hint">Duplo clique para pesquisar@if (barraSaldoPorTipo.temOutros) {
                · Clique em "Outros" para detalhar
              }</p>
              <div (click)="onClickBarraSaldoPorTipo($event, barraSaldoTipoRef)" (dblclick)="buscarCategoriaBarraSaldoChart($event, barraSaldoTipoRef, true)">
                <p-chart #barraSaldoTipoRef type="bar" [height]="barraSaldoPorTipo.altura" [data]="barraSaldoPorTipo.chartData" [options]="chartOptionsBarraSaldo" />
              </div>
            </div>
          }

        </div>
